import { useAuth0 } from '@auth0/auth0-react';
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const VerifiedRoute = (props: { isVerified: boolean; children: JSX.Element }) => {
  const { isLoading, isAuthenticated, user, getAccessTokenSilently } = useAuth0();

  if (props.isVerified === false && !isLoading) {
    return <Navigate to="/register" />;
  }

  return props.children;
};

export default VerifiedRoute;
